export class ItembudgetCategory {
    grupoId?: string;
    id?: string;
    nome?: string;
    valor?: number;
    metroQuadrado?: number;
    metroQuadradoAdicional?: number;
}